import { Component, OnInit, Input, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { ClusterModel } from '../cluster.model';
import { StateAccessCheckService } from '@fi-shared/fi-shared-services/state-access-check.service';
import { StatisticService } from '@fi-shared/statistic/statistic.service';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { ModuleType } from '@fi-shared/types/module-type';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { ClusterService } from '@fi-app/cluster/cluster.service';
import { FiItemsDeleteHelperService } from '@fi-shared/fi-shared-services/fi-items-delete-helper.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { DetectDevicesService } from '@fi-shared/fi-shared-services';
import { EditTabsModel } from '@fi-app/utilities/edit-tabs/edit-tabs.model';
import { MoreMenuMobileSettingsModel } from '@fi-app/utilities/more-menu-mobile/more-menu-mobile-settings.model';
import { AppTextService } from '@fi-shared/app-text';
import { BusinessUnitService } from '@fi-app/business-unit/business-unit.service';
import { FiDisplayType } from '@fi-shared/types/display-type';

@Component({
    selector: 'fi-cluster-view',
    templateUrl: './cluster-view.component.html',
    styleUrls: ['./cluster-view.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-cluster-view' },
    standalone: false,
})
export class ClusterViewComponent implements OnInit {
    @Input('cluster') Cluster: ClusterModel;
    hasEditAccess: boolean = false;
    FiStateNames = FiStateNames;
    editTabs: EditTabsModel;
    moreMenuItems: MoreMenuMobileSettingsModel;

    constructor(
        private stateAccessCheckService: StateAccessCheckService,
        private statisticService: StatisticService,
        private stateService: FiStateService,
        private clusterService: ClusterService,
        private itemsDeleteHelperService: FiItemsDeleteHelperService,
        private detectDevicesService: DetectDevicesService,
        private appTextService: AppTextService,
        private businessUnitService: BusinessUnitService,
    ) {}

    ngOnInit() {
        this.setPageHeaderData();
        this.statisticService.Visit(ModuleType.Core, ObjectTypes.Cluster, this.Cluster.Id);
    }

    private setPageHeaderData() {
        this.hasEditAccess = this.stateAccessCheckService.isStateAllowedForCurrentUser(FiStateNames.Cluster.Edit);
        this.editTabs = new EditTabsModel(
            `${this.appTextService.get('common.cluster')}: ${this.Cluster.Name}`,
            this.appTextService.get('back'),
        );
        this.moreMenuItems = new MoreMenuMobileSettingsModel();

        if (this.hasEditAccess) {
            this.moreMenuItems.AddListItem(this.appTextService.get('common.edit'), () => this.editCluster());
            this.moreMenuItems.AddListItem(this.appTextService.get('common.delete'), () => this.deleteCluster());
        }
    }

    isMobilePhone(): boolean {
        return this.detectDevicesService.isMobilePhone();
    }

    editCluster() {
        this.stateService.go(FiStateNames.Cluster.Edit, { Id: this.Cluster.Id });
    }

    deleteCluster() {
        this.itemsDeleteHelperService.commonDeleteConfirm(ObjectTypes.Cluster, [this.Cluster]).then(() => {
            this.clusterService.deleteClusters([this.Cluster.Id]).then(() => {
                this.itemsDeleteHelperService.showDeletedObjectSimpleSnackBar(
                    ObjectTypes.Cluster,
                    [this.Cluster.Id],
                    this.Cluster.Name,
                );
                window.history.back();
            });
        });
    }

    openBusinessUnitProfileDialog(businessUnitId: number) {
        this.businessUnitService.openBusinessUnitViewDialog(businessUnitId);
    }

    protected readonly FiDisplayType = FiDisplayType;
}
